module.exports = __webpack_public_path__ + "static/media/rate-twilight.c43486db.svg";